<template>
  <div class="send-wishlist">
    <h3 class="wishlist-area__cart__contents__step__h3" v-html="$t('wishlist.dataInsert')"></h3>
    <p class="wishlist-area__cart__contents__step__p" v-html="$t('wishlist.yourData')"></p>
    <p class="wishlist-area__cart__contents__step__p wishlist-area__cart__contents__step__p2" v-html="$t('forms.privacyText04')"></p>
    <form @submit.prevent="$_sendForm">
      <label class="send-wishlist__alreadyCustomer">{{ $t('wishlist.alreadyCustomer') }}</label>
      <div class="send-wishlist__radios" :class="{ 'errorinput': errors.has('customer')}">
        <p>
          <input type="radio" id="test1" name="customer" v-model="customer" :value="$t('common.yes')" v-validate="'required'">
          <label for="test1">{{ $t('common.yes') }}</label>
        </p>
        <p>
          <input type="radio" id="test2" name="customer" v-model="customer" :value="$t('common.no')">
          <label for="test2">{{ $t('common.no') }}</label>
        </p>
      </div>
      <!--<input type="hidden" v-model="productLines" >-->
      <input v-model="name" v-validate="'required'" :class="{ 'errorinput': errors.has('name')}" type="text" name="name" :placeholder="$t('forms.name')">
      <!-- <p>{{ errors.first('name') }}</p> -->
      <input v-model="surname" v-validate="'required'" :class="{ 'errorinput': errors.has('surname')}" type="text" name="surname" :placeholder="$t('forms.surname')">
      <input v-model="company" v-validate="'required'" :class="{ 'errorinput': errors.has('company')}" type="text" name="company" :placeholder="$t('forms.company')">
      <input v-model="email" v-validate="'required|email'" :class="{ 'errorinput': errors.has('email')}" type="email" name="email" placeholder="Email">
      
      <input v-model="city" v-validate="'required'" :class="{ 'errorinput': errors.has('city')}" type="text" name="city" :placeholder="$t('forms.city')">
      <input v-model="province" v-validate="'required'" :class="{ 'errorinput': errors.has('province')}" type="text" name="province" :placeholder="$t('forms.province')">

      <input v-model="telephone" v-validate="'required'" :class="{ 'errorinput': errors.has('telephone')}" type="text" name="telephone" :placeholder="$t('forms.telephone')">
      <label class="send-wishlist__label-message">{{ $t('forms.message') }}</label>
      <textarea v-model="message" v-validate="'required'" :class="{ 'errorinput': errors.has('message')}" name="message"></textarea>
      <div class="custom-checkbox" :class="{ 'errorinput': errors.has('privacy')}">
        <p style="text-decoration: none">{{ $t('forms.articles') }}</p>
        <input v-model="privacy" v-validate="'required'" name="privacy" type="checkbox" id="privacy"/>
        <label for="privacy">{{ $t('forms.privacyText01') }} <router-link :to="{ name: `${lang}.single-page`, params: { slug: 'privacy-policy' } }">Privacy Policy</router-link> {{ $t('forms.privacyText02') }}</label>
      </div>
      <div class="custom-checkbox">
        <input v-model="newsletter" name="newsletter" type="checkbox" id="newsletter"/>
        <label for="newsletter">{{ $t('forms.privacyText03') }}</label>

        <p>{{ $t('forms.privacyText04') }}</p>
      </div>
      <button 
        :class="{'send-wishlist-button--enabled': buttonEnabled}">
        {{ $t('forms.send') }}
      </button>
    </form>
  </div>
</template>

<script>

import axios from 'axios'
import { mapGetters } from 'vuex'
import { load } from 'recaptcha-v3'

export default {
  name: 'SendWishlist',
  data: () => ({
    name: '',
    surname: '',
    company: '',
    email: '',
    city: '',
    province: '',
    telephone: '',
    message: '',
    customer: '',
    privacy: '', // privacy.repeat(20),
    newsletter: false,
    token: '',
    buttonEnabled: true,
    // json_fields: undefined
  }),
  computed: {
    ...mapGetters('wishlist', [
      'wishlist'
    ]),
    ...mapGetters([
      'lang'
    ]),
    wishlistTag: {
      get () {
        if (this.wishlist.length === 0) return ''
        const elements = this.wishlist.map((product) => {
          return {
            sys: {
              type: product.sys.type,
              linkType: 'Entry',
              id: product.sys.id
            }
          }
        })
        return elements
      }
    },
    wishlistJson: {
      get () {
        if (this.wishlist.length === 0) return ''
        const elements = this.wishlist.map((product) => {
          return {
            fields: {
              id: product.sys.id,
              locale: product.sys.locale,
              title: product.fields.title,
              slug: product.fields.slug,
              productCode: product.fields.productCode,
              productThumbnail: product.fields.productThumbnail.fields.file.url
            }
          }
        })
        return elements
      }
    },
    /*productLines () {
      const prods = {"productsJson" : [...this.wishlistJson]}
      return  prods
    }*/
  },
  methods: {
    /* normalizeLines(lines) {
      //const normalizedLines = []
      const arrayNew = new Array()
      lines.forEach((line) => {
        const dataObj = {}
        dataObj.slug = line.fields.slug
        dataObj.productThumbnail = line.fields.productThumbnail
        dataObj.title= line.fields.title
        dataObj.productCode= line.fields.productCode
        arrayNew.push(dataObj)
        
      })
      return arrayNew
    },*/
    $_validateBeforeSubmit () {
      return this.$validator.validateAll()
    },
    async $_sendForm () {
      // validate inputs
      const validated = await this.$_validateBeforeSubmit()
      if (validated) {
        if (this.buttonEnabled) {
          this.buttonEnabled = false
          // load recaptcha token
          const recaptcha = await load('6Lftjp0UAAAAAFrIzwIo0-aMdMG7DGEqWylmpNLx')
          this.token = await recaptcha.execute('homepage')

          if (typeof this.token !== 'undefined') {
            const submissionResult = await this.$_post({
              name: this.name,
              surname: this.surname,
              company: this.company,
              email: this.email,
              city: this.city,
              province: this.province,
              telephone: this.telephone,
              message: this.message,
              customer: this.customer === 'si', // boolean
              // customer: true,
              newsletter: this.newsletter, // boolean,
              products: this.wishlistTag,
              productsJson: this.wishlistJson,
              token: this.token,
              json_fields: this.json_fields
            })
            if (submissionResult) this.$emit('success') // success
            else this.$emit('failure') // failure
          }
          // subscribe to mailchimp
          if (!this.newsletter) return
          this.$_mailchimpSubscribe()
        }
      }
    },
    async $_mailchimpSubscribe () {
      try {
        const list = this.lang === 'it' ? process.env.VUE_APP_MAILCHIMP_LIST_ID_IT : process.env.VUE_APP_MAILCHIMP_LIST_ID_EN
        const mailchimp = await axios.post(`https://europe-west1-glaxi-6c4fe.cloudfunctions.net/mailchimp/list/${list}/members/create`,
          {
            emailAddress: this.email,
            status: 'subscribed',
            mergeFields: {
              'FNAME': this.name,
              'LNAME': this.surname,
              'MMERGE5': this.company,
              'PHONE': this.telephone
            }
          }
        )
        if (mailchimp.status === 'pass') return true
        return false
      } catch (err) {
        return false
      }
    },
    async $_post (postData) {
      // recupero la lingua
      var submittedLang = this.lang === 'it' ? 'it' : 'en-US'
      // const json_fields = postData.productsJson
      // const productsLines = this.normalizeLines(postData.productsJson)
  
 
      //const apiId = this.lang === 'it' ? 'c438f51e-0f69-4e2b-a7a4-bd9078c8b538' : '868e525c-6b1b-402a-8d27-dc65fddd1ebe'
      /*const apiId = '5db819ce-d3b3-47f2-8cb9-1c57eb5576ff'
      
        if (typeof postData.token !== 'undefined') {
          try {
            const formData = new FormData()
            formData.append('json_fields',  'productsJson' )
            formData.append('captcha', postData.token)
            formData.append('api_id', apiId)
            formData.append('name', postData.name)
            formData.append('surname', postData.surname)
            formData.append('company', postData.company)
            formData.append('telephone', postData.telephone)
            formData.append('city', postData.city)
            formData.append('province', postData.province)
            formData.append('email', postData.email)
            formData.append('message', postData.message)
            formData.append('customer', postData.customer)
            formData.append('products', JSON.stringify(postData.products))
            formData.append('productsJson', JSON.stringify(this.productLines))
            formData.append('newsletter', postData.newsletter)
            const sendMail = await axios.post('https://qpostin.herokuapp.com/emails/', formData)
           
            if (sendMail.status === 200) {
              
              return true
            }
            
            return false
          } catch (err) {
            
            return false
          }
        }*/

     try {
        const validateRecaptcha = await axios.post('https://europe-west1-glaxi-6c4fe.cloudfunctions.net/recaptcha/validate', {
          fields: {
            title: {
              [submittedLang]: postData.email + ' on ' + new Date().toUTCString()
            },
            name: {
              [submittedLang]: postData.name
            },
            surname: {
              [submittedLang]: postData.surname
            },
            company: {
              [submittedLang]: postData.company
            },
            email: {
              [submittedLang]: postData.email
            },
            city: {
              [submittedLang]: postData.city
            },
            province: {
              [submittedLang]: postData.province
            },
            telephone: {
              [submittedLang]: postData.telephone
            },
            message: {
              [submittedLang]: postData.message
            },
            customer: {
              [submittedLang]: postData.customer
            },
            newsletter: {
              [submittedLang]: postData.newsletter
            },
            products: {
              [submittedLang]: postData.products
            },
            productsJson: {
              [submittedLang]: postData.productsJson
            }
          },
          context: {
            token: postData.token,
            model: 'requests'
          }
        })
        if (validateRecaptcha.data.status === 'pass') return true
        return false
      } catch (err) {
        console.log('validateRecaptcha', err)
        return false
      }
    }
  }
}
</script>

<style lang="scss">
  @import "./form.scss";
</style>
